import { injectable } from 'inversify'
import type { AxiosResponse } from 'axios'
import type { HttpInterceptor } from '@/services/transport/types'
import { TmTransportNoResponseError } from '@/core/error/transport/TmTransportNoResponseError'

@injectable()
export default class NoResponseInterceptor implements HttpInterceptor {
  public response(response: AxiosResponse) {
    if (!response.status) {
      throw new TmTransportNoResponseError('Response with no status', {
        method: response.config.method,
        url: response.config.url,
      })
    }

    return response
  }
}
